import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import RefTextInput from '../RefTextInput';
import { MessengerAdModel } from '@mm/state/model/MessengerAdModel';
import Button from '../../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import copyIcon from 'assets/icons/copy-orange.svg';
import JSONUtils from '@mm/state/helpers/json-utils';
import JSONCodeTextArea from '../JSONCodeTextArea';
import convertKeys from 'convert-keys';

type OuterProps = {
  ad: MessengerAdModel;
};

const ManualSync = ({ ad }: OuterProps) => (
  <div className="ad-details-sync__manual-sync">
    Use the manual option if you want to create multiple Messenger Ad setups and
    apply them within the same campaign. Follow steps below then copy and paste
    the JSON and URL Parameters into the Facebook Ads manager as outlined in the
    help doc.
    <div className="ad-details__url-block">
      <RefTextInput text={`ref=${ad.searchToken}`} />
      <CopyToClipboard text={`ref=${ad.searchToken}`}>
        <Button>
          <img src={copyIcon} alt="" className="ad-details__copy-icon" />
          Copy
        </Button>
      </CopyToClipboard>
    </div>
    <div className="ad-details__json-block">
      <JSONCodeTextArea
        code={JSON.stringify(convertKeys.toSnake(ad.code), undefined, 4)}
      />
      <div>
        <CopyToClipboard
          text={JSONUtils.toString(convertKeys.toSnake(ad.code))}
        >
          <Button>
            <img src={copyIcon} alt="" className="ad-details__copy-icon" />
            Copy
          </Button>
        </CopyToClipboard>
      </div>
    </div>
  </div>
);

export default ManualSync;
